import { DialogOptions, dialogState } from '@/plugins/app-dialog/dialog-state';
import AppDialog from '@/plugins/app-dialog/dialog.vue';
import { App, inject, Plugin } from 'vue';

export interface appDialogAction {
    show(options: DialogOptions): Promise<boolean>;

    confirm(options: Omit<DialogOptions, 'title'>): Promise<boolean>;
}

const dialog: appDialogAction = {
    show(options) {
        return new Promise<boolean>(resolve => {
            Object.assign(dialogState, {
                visible: true,
                title: options.title ?? '',
                message: options.message,
                confirmText: options.confirmText ?? 'Yes',
                cancelText: options.cancelText ?? 'No',
                resolver: resolve
            });
        });
    },

    confirm(options) {
        return this.show({
            title: 'Confirmation',
            ...options
        });
    }
};

export default {
    install(app: App) {
        app.component('ApDialog', AppDialog);
        app.provide('appDialog', dialog);
        app.config.globalProperties.$appDialog = dialog;
    }
} as Plugin;

export function useAppDialog() {
    const dialog = inject<appDialogAction>('appDialog');

    if (!dialog) {
        throw new Error('No dialog provided');
    }

    return dialog;
}

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $appDialog: appDialogAction;
    }
}
